'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initSendSMSForm = initSendSMSForm;
exports.formatDataForSMSSendout = formatDataForSMSSendout;
exports.submitSMSForm = submitSMSForm;
exports.sendSMS = sendSMS;

var _phoneUtils = require('@fr/phone-utils');

/**
 * Inits the Send SMS "faux" form.
 *
 * @param {string} formWrapper DOM element wrapping the "faux" form.
 * @param {string} sendCallback Callback function to be called when the send
 *                              link button is clicked.
 */
function initSendSMSForm(formWrapper, sendCallback) {

  if (formWrapper && sendCallback) {

    var sendLinkButton = formWrapper.querySelector('[name="sendLink"]'),
        requiredFields = formWrapper.querySelectorAll('\n                             [name="mobileNumber"],\n                             [name="countryPrefix"]\n                           ');

    // Checks if all required elements that we need from the form are there.
    if (requiredFields.length !== 2) {
      throw new Error('Enable to init SMS Form because of missing field(s)');
    }

    // Binds the sendCallback to the click event of the button if present.
    if (sendLinkButton) {
      sendLinkButton.addEventListener('click', sendCallback);
    } else {
      throw new Error('Enable to init SMS Form because of missing send link button');
    }
  } else {
    throw new Error('Enable to init SMS Form because of invalid parameters');
  }
};

/**
 * Validates the Send SMS "faux" form as well as extract the data from it and
 * format it in a format consumable by the sensSMS function.
 *
 * @param {object} formWrapper DOM element wrapping the "faux" form.
 *
 * @return {object} Data to be passed to the sendSMS function.
 */
function formatDataForSMSSendout(formWrapper) {

  var countryPrefix = formWrapper.querySelector('[name="countryPrefix"]'),
      mobileNumber = formWrapper.querySelector('[name="mobileNumber"]'),
      mobileNumberHint = formWrapper.querySelector('.js-sms-form__mobile-number-hint'),
      hiddenFields = formWrapper.querySelectorAll('[type="hidden"]'),
      errorAlert = formWrapper.querySelector('.js-sms-form__error-alert');

  if (mobileNumber.value && Number.isInteger(Number(mobileNumber.value))) {

    var formData = {
      mobileNumber: (0, _phoneUtils.formatPhoneNumber)(countryPrefix.value, mobileNumber.value)

      // Appends the hidden fields to the return data.
    };hiddenFields.forEach(function (field) {
      formData[field.getAttribute('name')] = field.value;
    });

    return formData;
  } else {
    // Gives feedback to the user about the error.
    errorAlert.textContent = mobileNumberHint.textContent;
  }
};

/**
 * Submits SMS form data.
 *
 * @param {object} formWrapper DOM element wrapping the "faux" form.
 * @param {object} sendSMSFunction Promise that sends the SMS via the SMS API.
 *
 * @return {object} Promise with a void result, if successful.
 */
function submitSMSForm(formWrapper, sendSMSFunction) {

  var technicalErrorHint = formWrapper.querySelector('.js-sms-form__technical-error-hint'),
      successHint = formWrapper.querySelector('.js-sms-form__success-hint'),
      errorAlert = formWrapper.querySelector('.js-sms-form__error-alert'),
      successAlert = formWrapper.querySelector('.js-sms-form__success-alert');

  return new Promise(function (resolve, reject) {

    // Resets.
    errorAlert.textContent = '';
    successAlert.textContent = '';

    var formData = formatDataForSMSSendout(formWrapper);

    // If an error occured dismiss submission.
    if (errorAlert.textContent.length > 0) {
      return reject();
    }

    sendSMSFunction(formData).then(function (result) {
      successAlert.textContent = successHint.textContent;
      return resolve();
    }).catch(function (error) {
      errorAlert.textContent = technicalErrorHint.textContent;
      return reject();
    });
  });
};

/**
 * Given a mobile number, sends a SMS that communicates some information to 
 * customer's mobile.
 *
 * @param {object} fetch       Promise that call the SMS service API.
 * @param {string} endpointURL URL to the API endpoint (without params).
 * @param {object} caseData    Object that contains the minimum necessary
 *                             information to contact the customer. See below:
 *                             {
 *                               mobileNumber: '491234432252'
 *                               ...
 *                             }
 *
 * @return {object} Promise that should deliver the response from the SMS API.
 */
function sendSMS(fetch, endpointURL, caseData) {

  return new Promise(function (resolve, reject) {

    if (!fetch || !endpointURL || !caseData) {
      return reject(new Error('Parameters can\'t be null'));
    }

    // Builds the query string.
    var queryParams = Object.keys(caseData).map(function (key) {
      return key + '=' + caseData[key];
    }),
        queryString = queryParams.join('&');

    if (caseData['mobileNumber']) {

      // Calls to SMS service to issue the text message.
      fetch(endpointURL + '?' + queryString, { method: 'POST' }).then(function (response) {
        var ok = response.ok,
            status = response.status,
            statusText = response.statusText;


        if (ok) {
          // The service has void return, so no need to return results.
          return resolve();
        } else {
          throw new Error(status + ' ' + statusText);
        }
      }).catch(function (error) {

        var message = 'Technical error occured while requesting the SMS API!';

        if (error.stack) {
          message += '\n' + error.stack;
        }

        return reject(new Error(message));
      });
    } else {
      return reject(new Error('Mandatory case data missing'));
    }
  });
}